export default __webpack_public_path__ + "static/media/google-play.5a3184fa.png";